module.exports = __webpack_public_path__ + "static/media/video_consent_start_record_hin.20f408a5.mp3";